/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_PermanentInputs */

const vi_api_keys_permanent = /** @type {(inputs: Api_Keys_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vĩnh viễn`)
};

/**

* @param {Api_Keys_PermanentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permanent = /** @type {((inputs?: Api_Keys_PermanentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_PermanentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permanent(inputs)
});